@if (showLoader() && !showLoadingOverlay()) {
  <div class="loading-container">
    <app-loading></app-loading>
  </div>
}
<app-debugger />

@if (getShouldOverlay()) {
  <app-overlay-transition
    [overlayText]="getOverlayTransitionText()"
    [isFullOverlay]="getIsFullOverlay()"
    [transitionTimeout]="getTransitionTimeout()"
  />
}

@if (getShouldBackgroundFade()) {
  <div class="fade-overlay overlay-navy" [@fadeLayerImage]="{ params: { duration: backgroundFadeOutTimeout } }"></div>
}

@if (getShouldBackgroundFadeIn()) {
  <div
    class="fade-overlay overlay-white"
    [@fadeInLayerImage]="{ params: { duration: getBackgroundFadeInTimeoutTimeout() } }"
  ></div>
}

@if (transitionService.showDarkMode) {
  <div class="presentation-dark-mode" [@fadeLayerImage]="{ params: { duration: darkModeTimeout } }"></div>
}

<div class="flex h-full boundary">
  <section
    [ngClass]="sideSectionService.sideContainerType === sideContainerType.NONE ? 'main' : 'main chatIsOpen'"
    (click)="closeSagModal()"
  >
    <!-- Banners -->
    <app-recording-banner></app-recording-banner>
    <app-group-share-recording-banner></app-group-share-recording-banner>

    @if (videoFiltersEnabled()) {
      <app-filter-controls></app-filter-controls>
    }

    <div
      class="main-above-section"
      [ngClass]="{
        'in-presentation-mode': isPresentationActive(),
        'hide-responsive-element': sideSectionService.sideContainerType !== sideContainerType.NONE,
      }"
    >
      <div id="social_map_container" class="social-map-container">
        <div class="social-map-container-inner columns is-gapless"></div>
      </div>
      <div class="overlay-sheet">
        @if (isSocialLoaded() && inSocial()) {
          <app-social-header
            [social]="social()"
            [inSocial]="inSocial()"
            [company]="company"
            [user]="user()"
            [isHost]="isHost()"
          ></app-social-header>
        }

        <!--
        TODO: this should be removed when we enter the room, but doing so kills mingle mode sound
        FIXME: adding inSocial to the if causes the component to re-initialize on leave room, leaving it in place causes memory leaks
        -->
        @if (isSocialLoaded() && pageLoaded()) {
          <app-welcome-wrapper
            [hidden]="!(user() && social() && !inSocial())"
            [user]="user()"
            [waitingForHostStep]="waitingForHostStep()"
            [event]="event"
            (joinSocial)="onJoinSocial($event)"
            (hostAdmissionRequired)="onHostAdmissionRequired($event)"
            (triggerTransitionOverlay)="triggerTransitionOverlay($event)"
          >
          </app-welcome-wrapper>
        }
      </div>

      @if (isMobile()) {
        <div class="mobile-minimap-wrapper">
          <app-social-mini-map
            class="mini-map"
            #minimap
            nativeCursor
            [user]="user()"
            *ngIf="social() && inSocial()"
            [ngClass]="{
              'hide-responsive-element': sideSectionService.sideContainerType !== sideContainerType.NONE,
            }"
          ></app-social-mini-map>
        </div>
      }
    </div>
    <div class="columns .is-centered is-paddingless is-marginless is-full-height is-flex social-stage">
      <!-- SOCIAL PLAYER  -->
      <div class="social-player column">
        <div id="parallax_viewport_container" class="parallax-container">
          <div
            id="scene_container"
            class="scene-container"
            [ngClass]="{ transitionOverlay: transitionOverlay() }"
            style="--color: {{ themeBackgroundColor() }}"
          >
            @if (social() && isBrowser) {
              <app-social-pixi-canvas #pixicanvas class="pixi-canvas-wrap"></app-social-pixi-canvas>
            }
          </div>
        </div>
      </div>
      <!-- / END SOCIAL PLAYER -->

      <!-- PRESENTATION  -->
      @if (displayPresentation()) {
        <div class="stage presenting" [ngClass]="{ 'stage-share': groupParticipantScreenShareActive() }">
          <app-presentation-presenter
            [captionsOpened]="closedCaptionsEnabled()"
            [isGroupSharing]="groupParticipantScreenShareActive()"
          ></app-presentation-presenter>
          @if (closedCaptionsFlagEnabled() && closedCaptionsEnabled()) {
            <app-closed-captions [presentationMode]="true"></app-closed-captions>
          }
          <app-presentation-drawer></app-presentation-drawer>
        </div>
      }

      @if (isBadgingModalOpen()) {
        <app-modal-badging-questions
          class="position-modal-badging-questions"
          [isMobile]="isMobileOrTablet()"
          [ngClass]="
            isMobileOrTablet() ? 'position-modal-badging-questions-mobile' : 'position-modal-badging-questions-desktop'
          "
        ></app-modal-badging-questions>
      }

      @if (inSocial() || transitionOverlay()) {
        <app-presentation-toolbar
          [social]="social()"
          [isPerforming]="someoneIsPerforming()"
          [showZoomControls]="!displayPresentation()"
          [isLoadingPresentation]="isLoadingPresentation()"
          class="position-presentation-toolbar"
          nativeCursor
        ></app-presentation-toolbar>
      }
      <!-- /PRESENTATION -->

      <!-- Zoom Controls -->
      @if (inSocial() || transitionOverlay()) {
        <app-zoom-pixi-world-controls
          nativeCursor
          [showZoomControls]="displayZoomControls()"
          class="position-zoom-control"
          [ngStyle]="{
            left: '0px',
            bottom: isBadgingModalOpen() ? '75%' : '74px',
            zIndex: 10,
          }"
        >
        </app-zoom-pixi-world-controls>
      }

      @if (showCaptionsMingleMode()) {
        <app-closed-captions [presentationMode]="false" class="closed-captions-mingle-mode"></app-closed-captions>
      }
    </div>
  </section>

  @if (inSocial() && social() && !transitionOverlay()) {
    <app-right-collapsible-section
      [isHost]="isHost()"
      [user]="user()"
      [social]="social()"
      class="hide-responsive-element"
    ></app-right-collapsible-section>
  }

  @if (inSocial()) {
    <app-modal-special-access
      [ngClass]="{ open: isSAGModalOpen(), admission: isSAGModalRequestAccess() }"
      class="position-modal-special-access"
    ></app-modal-special-access>
  }

  @if (transitionOverlay()) {
    <app-welcome-room-transition [isHost]="isHost()" [social]="social()" [user]="user()"></app-welcome-room-transition>
  }

  @if (shouldShowBadge()) {
    <app-badging-info></app-badging-info>
  }
</div>
